import { defineStore } from 'pinia'
import { ref } from 'vue'
import api from '~/player/api/client'

// bar 專用狀態：provider 清單快取 + 遊戲搜尋查詢（綁 provider，供返回時還原）
export const useGameNavStore = defineStore('gameNav', () => {
  const providers = ref([])
  let loaded = false

  // 遊戲搜尋查詢與其所屬 provider id；進遊戲頁→返回時用來還原搜尋結果
  const gameQuery = ref('')
  const gameQueryProviderId = ref(null)

  async function ensureProviders() {
    if (loaded) return
    try {
      const { data } = await api.get('/providers')
      providers.value = data.data
      loaded = true
    } catch (e) {
      console.warn('[gameNav] load providers failed', e)
    }
  }

  function setGameQuery(q, providerId) {
    gameQuery.value = q
    gameQueryProviderId.value = providerId != null ? String(providerId) : null
  }

  function clearGameQuery() {
    gameQuery.value = ''
    gameQueryProviderId.value = null
  }

  // 登出時重置，避免換玩家登入後沿用上一位的資料
  function reset() {
    providers.value = []
    loaded = false
    clearGameQuery()
  }

  return { providers, ensureProviders, gameQuery, gameQueryProviderId, setGameQuery, clearGameQuery, reset }
})
